import React from 'react';

interface SemanticSegmentationIconV2Props {
  style?: React.CSSProperties;
}

const SemanticSegmentationIconV2: React.FC<SemanticSegmentationIconV2Props> = ({ style }) => {
  return <img style={style} src="/static/images/semantic-segmentation.png" />;
};

export default SemanticSegmentationIconV2;
